const MuiTabs = {
  styleOverrides: {
    flexContainer: {
      justifyContent: 'space-around',
    },
  },
}

export default MuiTabs
